import { render, staticRenderFns } from "./searchView.vue?vue&type=template&id=5526fc04&scoped=true&"
import script from "./searchView.vue?vue&type=script&lang=js&"
export * from "./searchView.vue?vue&type=script&lang=js&"
import style0 from "./searchView.vue?vue&type=style&index=0&id=5526fc04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5526fc04",
  null
  
)

export default component.exports